import { useState } from "react";

import { BWAFilterOptions } from "../../../types";
import { getBerlinMomentTimezone } from "../../common/helpers";
import { SAVE_DATE_FORMAT } from "../../../constants";
import {
  UserInfoExcerptWrapper,
  UserInfoWrapper,
  UserNameWrapper,
  ViewMoreWrapper,
} from "../../common/UserInfoExcerpt/styledComponents";
import useEmailParam from "../../hooks/useEmailParam";

import ArrowRight from "../../../svgs/arrow-right.svg?react";
import UserInfoExcerpt from "../../common/UserInfoExcerpt";
import { UserInfoDrawerSources } from "../../common/UserInfoExcerpt/UserInfoDrawer";
import { ContentWrapper } from "../../common/styledComponents";
import {
  KontaxUserContext,
  useKontaxUserContext,
} from "../../contexts/KontaxUserContext";
import BWAHeader from "./BWAHeader";
import BWAStatsTable from "./BWAStatsTable";

const UserInfo = () => {
  const { user, notes, isLoading } = useKontaxUserContext();

  return (
    <UserInfoExcerpt
      user={user}
      notes={notes}
      source={UserInfoDrawerSources.ACCOUNTING}
      isLoading={isLoading}
      renderExcerptData={(excerptData) => {
        return (
          <UserInfoExcerptWrapper>
            <UserNameWrapper>
              {excerptData.user.firstName} {excerptData.user.lastName}
            </UserNameWrapper>

            <span>
              {excerptData.vatDetails?.isKleinunternehmer && (
                <UserInfoWrapper>Kleinunternehmer</UserInfoWrapper>
              )}
              {excerptData.user.businessTypeComment && (
                <UserInfoWrapper>
                  {excerptData.user.businessTypeComment}
                </UserInfoWrapper>
              )}
              <UserInfoWrapper>
                {excerptData.vatDetails?.frequency} (
                {excerptData.vatDetails?.year})
              </UserInfoWrapper>
              <UserInfoWrapper>{excerptData.notesCount}</UserInfoWrapper>
            </span>

            <ViewMoreWrapper>
              <span>View more info</span>
              <ArrowRight />
            </ViewMoreWrapper>
          </UserInfoExcerptWrapper>
        );
      }}
    />
  );
};

const BWAView = () => {
  const [emailParam, setEmailParam] = useEmailParam();
  const [filterOptions, setFilterOptions] = useState<BWAFilterOptions>({
    email: emailParam || "",
    /*
     * "Today" is a Berlin day, not a browser-local one. maxDate in the header is
     * Berlin-based, so a browser-local default can land a day beyond it around
     * midnight or New Year and the picker then rejects its own default.
     * The values themselves stay plain calendar dates (SMT-720).
     */
    dateTo: getBerlinMomentTimezone().format(SAVE_DATE_FORMAT),
    dateFrom: getBerlinMomentTimezone()
      .startOf("year")
      .format(SAVE_DATE_FORMAT),
  });

  return (
    <ContentWrapper>
      <KontaxUserContext email={filterOptions.email}>
        <BWAHeader
          email={filterOptions.email}
          changeHandler={(updatedFilterOptions: Partial<BWAFilterOptions>) => {
            const newFilterOptions = {
              ...filterOptions,
              ...updatedFilterOptions,
            };
            setFilterOptions(newFilterOptions);
            setEmailParam(newFilterOptions.email || undefined);
          }}
        />
        <UserInfo />
        <BWAStatsTable filterOptions={filterOptions} />
      </KontaxUserContext>
    </ContentWrapper>
  );
};

export default BWAView;
